import type { ComponentType } from "react";

let modulesPromise: Promise<{
  ConfigurationPage: ComponentType;
  ImportData: ComponentType;
  AttributeMapping: ComponentType;
  DisplayOptionsOutlet: ComponentType;
}> | null = null;

const loadConfigurationRouteModules = async () => {
  try {
    const [
      { ConfigurationPage },
      { ImportData, AttributeMapping, DisplayOptionsOutlet },
    ] = await Promise.all([
      import("./ConfigurationPage"),
      import("./outlets/lazy"),
    ]);

    modulesPromise ??= Promise.resolve({
      ConfigurationPage,
      ImportData,
      AttributeMapping,
      DisplayOptionsOutlet,
    });

    return await modulesPromise;
  } catch (error) {
    modulesPromise = null;

    throw error;
  }
};

export { loadConfigurationRouteModules };
